/// <reference path="../../services/auth.service.js" />
const mod = require('../../bahabot.module.js')


/**
 * @param {AuthService} AuthService
 * @param {angular.ILocationService} $location
 * @param {angular.route.IRouteService} $route
 */
function bbLoginController(AuthService, $location, $route) {
    this.config = $route.current.locals.oauthConfig ?? {
        idpEnabled: false,
        idpExclusive: false,
        idpName: "Identity Provider"
    }

    this.idpErrorMap = {
        token_state_error: 'State mismatch, please try again!',
        token_exchange_error: 'Unable to exchange code for token! Please try again later!',
        token_extract_error: 'Unable to extract user information! Please try again later!',
        token_verify_error: 'Unable to verify token! Please try again later!',
        claim_extract_error: 'Unable to extract claims! Please try again later!',
        not_authorized: 'Your account is not authorized to use Bahabot.',
        session_save_failed: 'Unable to save session! Please try again later!',
    }

    this.idpNoticeMap = {
        logged_out: 'You have been logged out!',
    }

    this.errors = {
        general: null,
        idp: null,
    }

    this.notices = {
        idp: null,
    }

    this.model = {
        username: "",
        password: ""
    }

    this.onSubmit = function(evt) {
        this.errors.general = null;
        this.errors.idp = null;

        AuthService.login(this.model)
            .then(r => {
                $location.path('/dashboard');
            })
            .catch(r => {
                this.errors.general = r.data.error;
            })
    }

    this.$onInit = function() {
        // grab error from query
        this.errors.idp = this.idpErrorMap[$location.search().idpError] ?? null;
        this.notices.idp = this.idpNoticeMap[$location.search().idpNotice] ?? null;

        // immediately redirect to idp if enabled and in exclusive mode
        // unless we have to display an error message
        if (this.config.idpExclusive && this.config.idpEnabled && this.errors.idp === null && this.notices.idp === null) {
            this.doOAuthLogin();
        }
    }

    this.doOAuthLogin = function() {
        window.location.href = "/api/public/oauth2";
    }
}

mod.component('bbLogin', {
    templateUrl: 'tpl/bb-login.component.html',
    bindings: {},
    controller: ["AuthService", "$location", "$route", bbLoginController]
});